function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import omit from 'ramda/src/omit';
import i18n from 'invision-core/src/components/i18n/i18n';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import CustomerCareKeys from '../../../../locales/keys';
import { getColumnDefinitions } from './product.service.relationship.modal.helper';
var ProductServiceRelationshipModalComponent = /*#__PURE__*/function () {
  function ProductServiceRelationshipModalComponent() {
    _classCallCheck(this, ProductServiceRelationshipModalComponent);
    Object.assign(this, {
      columnDefs: getColumnDefinitions(),
      CustomerCareKeys: CustomerCareKeys,
      defaultSelectOption: {
        label: i18n.translate(CoreLocaleKeys.SELECT),
        value: undefined
      },
      productServiceRelationships: []
    });
  }
  return _createClass(ProductServiceRelationshipModalComponent, [{
    key: "$onChanges",
    value: function $onChanges(_ref) {
      var _this = this;
      var consumeServices = _ref.consumeServices;
      if (consumeServices && consumeServices.currentValue.length) {
        this.productServiceRelationships = clone(consumeServices.currentValue).map(function (consumeService) {
          var selectedProvidesPlan = consumeService.ProviderPlanDetail ? {
            label: consumeService.ProviderPlanDetail.PricingPlanName,
            value: consumeService.ProviderPlanDetail.PricingPlanId.Value
          } : _this.defaultSelectOption;
          return _objectSpread(_objectSpread({}, consumeService), {}, {
            isDisabled: !(consumeService.LinkableProviderPlans || []).length,
            providesPlans: [_this.defaultSelectOption].concat((consumeService.LinkableProviderPlans || []).map(function (providesPlan) {
              return {
                label: providesPlan.PricingPlanName,
                value: providesPlan.PricingPlanId.Value
              };
            })),
            selectedProvidesPlan: selectedProvidesPlan
          });
        });
      }
    }
  }, {
    key: "onSave",
    value: function onSave() {
      var updatedProductServiceRelationships = this.productServiceRelationships.map(function (consumeService) {
        return omit(['providesPlans', 'selectedProvidesPlan', 'isDisabled', 'serviceAttributeName'], _objectSpread(_objectSpread({}, consumeService), {}, {
          ProviderPlanDetail: consumeService.LinkableProviderPlans.find(function (providesPlan) {
            return providesPlan.PricingPlanId.Value === consumeService.selectedProvidesPlan.value;
          })
        }));
      });
      this.onSubmit()(updatedProductServiceRelationships);
    }
  }]);
}();
export default {
  bindings: {
    consumeServices: '<',
    onClose: '&',
    onSubmit: '&'
  },
  controller: ProductServiceRelationshipModalComponent,
  template: require('./product.service.relationship.modal.template.html')
};